// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"83c7b0e3","601":"84f5e9d5","787":"6b98f582"}[chunkId] + ".chunk.js";
};